// Core features needed in all subsites
import './modules/core';

/* ========================================================================
 * ruoka.palmia.fi specific (legacy stuff, just modularized a bit)
 * MAKE MODULES IF YOU DO ANYTHING NEW
 * ======================================================================== */

import $ from 'jquery';
import Mustache from 'mustache';

import imageCarousel from './modules/image-carousel';
import conferenceRoomSearch from './modules/conference-room-search';

imageCarousel.init();
conferenceRoomSearch.init();

$(function() {

  // Old palmia.js stuff that is actually ruoka.palmia.fi stuff.

  //LOGIC of food palmias newslist
  if($('.restaurant-newslist').length > 0) {
    var heroTemplate = $('#hero-mustache-template').html();
    Mustache.parse(heroTemplate); // optional, speeds up future uses

    var newsListItemTemplate = $('#news-list-item-mustache-template').html();
    Mustache.parse(newsListItemTemplate); // optional, speeds up future uses


    $('.restaurant-newslist .invidual-restaurant-button.news-list-filter').click(function() {
      if(typeof window.newsList === 'undefined' || window.newsList.length === 0) {
        return;
      }

      var type = $(this).attr('data-type');
      var searchTerm = '';
      var tmpList = [];

      switch (type) {
      case 'themes':
        searchTerm = 'Teema';
        break;
      case 'news':
        searchTerm = 'Uutinen';
        break;
      case 'releases':
        searchTerm = 'Tiedote';
        break;
      }

      if(searchTerm === '') {
        //all
        tmpList = window.newsList;
      }
      else {
        for(var i = 0; i < window.newsList.length; i++) {
          if(window.newsList[i].type === searchTerm) {
            tmpList.push(window.newsList[i]);
          }
        }
      }

      var el = tmpList[0];
      $('#news-list-hero-container').empty().append(
        Mustache.render(heroTemplate, {
          'link': el.url_path,
          'title_image': el.image_href_1040x,
          'types': el.type,
          'title': el.short_title,
          'tags': el.publish_time_str,
          'ingress': el.teaser,
          'read_more_copy': window.newsListTrans.read_article
        })
      );
      $('#news-list-items-container').empty();
      for(i = 1; i < tmpList.length; i++) {
        el = tmpList[i];
        $('#news-list-items-container').append(
          Mustache.render(newsListItemTemplate, {
            'link': el.url_path,
            'image': el.image_href_640x,
            'publish_time': el.publish_time_str,
            'types': el.type,
            'title': el.short_title,
            'tags': el.publish_time_str,
            'ingress': el.teaser,
            'read_more_copy': window.newsListTrans.read_article,
            'not_cols': true,
            'extra_classes': 'grid-item',
            'theme': ''
          })
        );
      }
      if( $('#news-list-items-container').children().length > 0) {
        //need to reload masonry again
        //initializeMasonry();
      }
    });
  }

  $('#openBookingTable').on('click', function() {
    $('#restaurantBooking').trigger('click');
  });

  function selectedSection(type) {
    //only using in invidual school and restaurant pages
    $('.invidual-restaurant-section-tab[data-sectiontype="' + type + '"]').addClass('selected');
    $('.invidual-restaurant-tab-selection-btn[data-btntype="' + type + '"]').addClass('selected');
  }

  // If information tab and hash is information select information tab
  if( $('.invidual-restaurant-tab-selection-btn[data-btntype="information"]').length > 0 && window.location.hash === '#information' ) {
    selectedSection('information');
  // If no hash defined try to select tab by section data
  } else if( typeof sectionData !== 'undefined' ) {
    /* eslint-disable */
    //javascript variable initialize in template
    selectedSection(sectionData);
    /* eslint-enable */
  }

  //Looking user location and add distances to restaurants
  //https://stackoverflow.com/questions/27928/calculate-distance-between-two-latitude-longitude-points-haversine-formula#answer-27943
  function getDistanceFromLatLonInKm(lat1,lon1,lat2,lon2) {
    var R = 6371; // Radius of the earth in km
    var dLat = deg2rad(lat2 - lat1); // deg2rad below
    var dLon = deg2rad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
  }
  //https://stackoverflow.com/questions/27928/calculate-distance-between-two-latitude-longitude-points-haversine-formula#answer-27943
  function deg2rad(deg) {
    return deg * (Math.PI / 180);
  }

  function getCurrentPosition() {
    if('geolocation' in navigator) {
      // check if geolocation is supported/enabled on current browser
      navigator.geolocation.getCurrentPosition(
        function success(position) {
          // for when getting location is a success
          updateDistances(position.coords);
        },
        function error(error_message) {
        // for when getting location results in an error
          console.error('An error has occured while retrieving location', error_message);
        }
      );
    } else {
      // geolocation is not supported
      // get your location some other way
    }
  }
  function updateDistances(coords) {
    //coords.latitude, coords.longitude;
    var pLat = coords.latitude;
    var pLng = coords.longitude;

    $('.restaurant-list-item').each(function() {
      var cLat = parseFloat($(this).data('lat'));
      var cLng = parseFloat($(this).data('lng'));

      var distance = getDistanceFromLatLonInKm(pLat, pLng, cLat, cLng);
      var distanceTxt = '';
      if(!isNaN(distance)) {
        if(distance < 1.0) {
          distanceTxt = Math.ceil(distance * 1000) + 'm';
        }
        else {
          distanceTxt = distance.toFixed(1) + 'km';
        }
      }
      if(distanceTxt !== '') {
        var items = [
          $(this)
            .children('.restaurant-list-item-text-container')
            .children('.restaurant-list-item-distance'),
          $(this).children('.restaurant-list-item-distance')
        ];
        var item;
        for(var i = 0; i < items.length; i++) {
          item = items[i];

          if(typeof item !== 'undefined' && item !== null && item.length > 0) {
            item
              .data('distance', distance)
              .text(' (' + distanceTxt + ')' );
          }
        }
      }
    });
    $('.invidual-restaurant').each(function() {
      var cLat = parseFloat($(this).data('lat'));
      var cLng = parseFloat($(this).data('lng'));

      var distance = getDistanceFromLatLonInKm(pLat, pLng, cLat, cLng);
      var distanceTxt = '';
      if(!isNaN(distance)) {
        if(distance < 1.0) {
          distanceTxt = Math.ceil(distance * 1000) + 'm';
        }
        else {
          distanceTxt = distance.toFixed(1) + 'km';
        }
      }
      if(distanceTxt !== '') {
        var item = $(this)
          .children('.invidual-restaurant-section-address-buttons')
          .children('.col-lg-4')
          .children('.invidual-restaurant-street-address')
          .children('.invidual-restaurant-distance');

        if(typeof item !== 'undefined' && item !== null && item.length > 0) {
          item
            .data('distance', distance)
            .text(' (' + distanceTxt + ')' );
        }
      }
    });
  }
  if($('.restaurant-list-item').length > 0 || $('.invidual-restaurant').length > 0) {
    getCurrentPosition();
  }

});
